module.exports = __webpack_public_path__ + "static/media/20201121_222839_369_IMG_1032.573a4b66.jpg";